/**
 * Age-band badge for Originals surfaces (Epic 20 S20.5).
 * Small pill with the age-band label, tinted via the shared age-band gradient.
 * Reused on the catalog cards and the story page (S20.6).
 *
 * @module components/originals/AgeBadge
 */

import type { AgeBand } from '@sagamoon/shared';
import { getAgeBandInlineStyle } from '../../utils/age-band-styles';

const AGE_BAND_LABEL: Record<AgeBand, string> = {
  '3-4': '3–4 v',
  '5-6': '5–6 v',
  '7-8': '7–8 v',
  '9-10': '9–10 v',
};

interface AgeBadgeProps {
  ageBand: AgeBand;
}

export function AgeBadge({ ageBand }: AgeBadgeProps): JSX.Element {
  return (
    <span
      className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold text-white"
      style={getAgeBandInlineStyle(ageBand)}
    >
      {AGE_BAND_LABEL[ageBand]}
    </span>
  );
}
